import React from "react";
import { PDF_PAGE_SIZES } from "../../utils/exportUtils";

/**
 * The PDF-specific part of the export modal (BBD-119), shared by Document.js
 * and WorkspaceDocument.js: the collapsed "Options" block and the status line
 * shown while the server works. The surrounding modal, the scope radios and
 * the buttons stay with each viewer.
 *
 * `combined` is true when the export will hold more than one document, which
 * is when a table of contents is on unless the user turned it off.
 */
function PdfExportOptions({ options, onChange, combined, status }) {
    const tocChecked = typeof options.includeToc === "boolean" ? options.includeToc : combined;

    return (
        <div className="PdfExport">
            <details className="PdfExport__options">
                <summary>Options</summary>

                <div className="PdfExport__row">
                    <label htmlFor="pdf-export-page-size">Page size</label>
                    <select
                        id="pdf-export-page-size"
                        value={options.pageSize}
                        onChange={(e) => onChange({ ...options, pageSize: e.target.value })}
                    >
                        {PDF_PAGE_SIZES.map((size) => (
                            <option key={size} value={size}>{size}</option>
                        ))}
                    </select>
                </div>

                <label className="PdfExport__check">
                    <input
                        type="checkbox"
                        checked={tocChecked}
                        onChange={(e) => onChange({ ...options, includeToc: e.target.checked })}
                    />
                    Include a table of contents
                </label>

                <label className="PdfExport__check">
                    <input
                        type="checkbox"
                        checked={options.includeMetadata}
                        onChange={(e) => onChange({ ...options, includeMetadata: e.target.checked })}
                    />
                    Include title, author and last-updated date
                </label>
            </details>

            {status && status.message && (
                <p className={`PdfExport__status PdfExport__status--${status.state}`} role="status">
                    {status.message}
                </p>
            )}
        </div>
    );
}

export default PdfExportOptions;
